import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoader = defineStore('loader', () => {

  const loader = ref(true)
  
  function open(){
    loader.value = true;
  }

  function close(){
    loader.value = false;
  }

  function toggle(){
    loader.value = !loader.value;
  }

  return { 
    loader,
    open,
    close,
    toggle
  }

})